import type {LayoutModelBranch} from '../../../types'
import {isChildOfStackContainer} from '../../common'
import {horizontalSpacingHeuristics, widthHeuristics} from './grid'
import {horizontalSpacingHeuristicsStack, widthHeuristicsStack} from './stack'

export const horizontalSpacingTree: LayoutModelBranch[] = [
    {scope: isChildOfStackContainer, heuristics: horizontalSpacingHeuristicsStack},
    {scope: () => true, heuristics: horizontalSpacingHeuristics}
]

export const widthTree: LayoutModelBranch[] = [
    {scope: isChildOfStackContainer, heuristics: widthHeuristicsStack},
    {scope: () => true, heuristics: widthHeuristics}
]
